import { TaskAssigneePrivacyEnum } from '@/bundles/Tasks/types';

export const taskAssigneePrivacyLabels: Record<string, string> = {
  [TaskAssigneePrivacyEnum.me]: 'My Tasks',
  [TaskAssigneePrivacyEnum.by_me]: 'My Assignments',
  [TaskAssigneePrivacyEnum.my_team]: "My Team's Tasks",
}
